export class JobProgressStepVolumeCreationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volumeId",
            "baseName": "volumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "availabilityZone",
            "baseName": "availabilityZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "volumeType",
            "baseName": "volumeType",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizeGib",
            "baseName": "sizeGib",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "iops",
            "baseName": "iops",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "throughputMibPerS",
            "baseName": "throughputMibPerS",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "encryptionKeyArn",
            "baseName": "encryptionKeyArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountName",
            "baseName": "accountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "consoleUrl",
            "baseName": "consoleUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepVolumeCreationData.attributeTypeMap;
    }
    constructor() {
    }
}
